import * as React from "react";
const SvgReview = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1.25A1.75 1.75 0 0 0 .25 3v14c0 .966.784 1.75 1.75 1.75h2.75V22a.75.75 0 0 0 1.166.624l5.748-3.832a.25.25 0 0 1 .139-.042H22A1.75 1.75 0 0 0 23.75 17V3A1.75 1.75 0 0 0 22 1.25H2ZM1.75 3A.25.25 0 0 1 2 2.75h20a.25.25 0 0 1 .25.25v14a.25.25 0 0 1-.25.25H11.803a1.75 1.75 0 0 0-.97.294L6.25 20.599V18a.75.75 0 0 0-.75-.75H2a.25.25 0 0 1-.25-.25V3Zm10.923 1.668a.75.75 0 0 0-1.346 0l-1.294 2.624-2.896.42a.75.75 0 0 0-.416 1.28l2.095 2.042-.494 2.884a.75.75 0 0 0 1.088.79l2.59-1.36 2.59 1.36a.75.75 0 0 0 1.088-.79l-.495-2.884 2.096-2.042a.75.75 0 0 0-.416-1.28l-2.896-.42-1.294-2.624Zm-1.47 3.641L12 6.695l.797 1.614a.75.75 0 0 0 .565.41l1.782.26-1.29 1.257a.75.75 0 0 0-.216.663l.305 1.775-1.594-.838a.75.75 0 0 0-.698 0l-1.594.838.305-1.775a.75.75 0 0 0-.216-.663l-1.29-1.257 1.782-.26a.75.75 0 0 0 .565-.41Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgReview;
